import type { GetIntegrationsDirectCdiSourcesSourceIdDistinctColumnValuesResult } from "./types";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function isGetIntegrationsDirectCdiSourcesSourceIdDistinctColumnValuesResult(
  value: unknown
): value is GetIntegrationsDirectCdiSourcesSourceIdDistinctColumnValuesResult {
  if (!isRecord(value)) {
    return false;
  }
  const values = value.values;

  return Array.isArray(values) && values.every((item: unknown) => typeof item === "string");
}
